import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flags/kz",
  "use": "flags/kz-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"flags/kz\">\n    <path fill=\"#408CFF\" d=\"M0 0h18v12H0z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z\" fill=\"#FFD21F\" />\n    <path fill=\"#FFD21F\" d=\"M1 2h1v8H1z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 9a4 4 0 0 1-4-4h1a3 3 0 0 0 6 0h1a4 4 0 0 1-4 4z\" fill=\"#FFD21F\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol